// extracted by mini-css-extract-plugin
module.exports = {"textarea":"pguhkT"};